import { createContext, ReactNode, useContext } from "react";

const context = createContext(1010);

export function StackContextProvider({ children }: { children: ReactNode }) {
  const previousStack = useStackContext();

  return (
    <context.Provider value={previousStack + 100}>{children}</context.Provider>
  );
}

export default function useStackContext() {
  return useContext(context) || 1010;
}
